import { Box, Typography } from "@mui/material";

const NoAvailableTime = ({ message, fontSize = "10px" }) => (
  <Box
    sx={{
      height: "338px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "#F2F2F2",
      width: "100%",
      borderRadius: "8px",
    }}
  >
    <Typography
      sx={{
        fontFamily: "var(--font-grenettepromedium)",
        fontSize,
        lineHeight: fontSize === "10px" ? "11px" : undefined,
        letterSpacing: fontSize === "10px" ? "0.07em" : undefined,
        color: "#A1A1A1",
        textTransform: "uppercase",
        textAlign: "center",
        whiteSpace: "pre-line",
      }}
    >
      {message}
    </Typography>
  </Box>
);

export default NoAvailableTime;
